import { render, staticRenderFns } from "./AskAQuestionAttachmentCard.vue?vue&type=template&id=c2f46d14&scoped=true"
import script from "./AskAQuestionAttachmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AskAQuestionAttachmentCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AskAQuestionAttachmentCard.vue?vue&type=style&index=0&id=c2f46d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f46d14",
  null
  
)

export default component.exports